import React, { FC } from 'react';
import EventCharts, { EventCharts as EventChartsInnerComponent } from '@components/machines/components/eventsChart';
import PerformanceScreensWrapper from '@v2/pages/performance/common/components/PerformanceScreensWrapper';
import { KEYS_TAGS } from '@components/imageHandling/common';
import { MachinesScreen } from '@v2/pages/machines/common/enums';

interface PerformanceActiveProps {}

const PerformanceActive: FC<PerformanceActiveProps> = () => {
  return (
    <PerformanceScreensWrapper>
      <EventCharts
        getContentElement={(props) => <EventChartsInnerComponent {...props} scope={KEYS_TAGS.Machine} />}
      />
    </PerformanceScreensWrapper>
  );
};

export default PerformanceActive;
